export default __webpack_public_path__ + "static/media/Picture3.885959ee.jpg";